import {chunkString} from '../../../string';

export const scheduleToBits = (schedule: string): string => {
  const hexBytes = chunkString(schedule, 2);

  return hexBytes
    .map(hexByte => parseInt(hexByte, 16).toString(2).padStart(8, '0'))
    .join('');
};
